import { NutrientsToDecrease } from "./../pages/nutrition/presentation/nutrients-to-decrease/nutrients-to-decrease";
import { NutrientsToIncrease } from "./../pages/nutrition/presentation/nutrients-to-increase/nutrients-to-increase";
import { NutrientIndicatorExplanation } from "./../pages/nutrition/answer/nutrient-indicator-explanation/nutrient-indicator-explanation";
import { GeneDataGroupArea, GeneDataGroupType } from "../api/smartmelts-api/graphql/generated";
import { BloodIcon } from "../assets/icons/blood-icon";
import { MetabolismIcon } from "../assets/icons/metabolism-icon";
import { MicronutrientsIcon } from "../assets/icons/micronutrients-icon";
import { NutritionIcon } from "../assets/icons/nutrition-icon";
import { OrganIcon } from "../assets/icons/organ-icon";
import {
  BLUE_COLOR,
  BLUE_COLOR_LIGHT,
  GREEN_COLOR,
  GREEN_COLOR_LIGHT,
  NEW_BLUE_COLOR,
  PRIMARY_COLOR,
  PRIMARY_COLOR_LIGHT,
  PURPLE_COLOR,
  PURPLE_COLOR_LIGHT,
  RED_COLOR,
  RED_COLOR_LIGHT,
  WARNING_COLOR,
  WARNING_COLOR_LIGHT,
  YELLOW_COLOR,
} from "../theme/theme";
import { BODYPART } from "./bodypart";
import { RecommendationsIcon } from "../assets/icons/recommendations-icon";
import { fade, lighten } from "@material-ui/core";
import { Overview } from "../pages/nutrition/presentation/overview/overview";
import {
  Explanation,
  IColorCategoryDictionary,
  IExplanationDictionary,
  IMenuCategoryDictionary,
  IMenuSubcategoryDictionary,
  MenuItemCategory,
  MenuItemSubcategory,
} from "./types/category-types";
import { UserData } from "../pages/nutrition/presentation/user-data/user-data";
import { UserFavourites } from "../pages/nutrition/presentation/user-data/user-favourites";
import { UserReports } from "./../pages/nutrition/presentation/user-reports/user-reports";
import { GeneVariations } from "../pages/nutrition/presentation/gene-variations/gene-variations";
import { GeneVariationExplanation } from "../pages/nutrition/answer/gene-variations/gene-variation-explanation";
import { GeneVariation } from "../pages/nutrition/answer/gene-variations/gene-variation";
import { MentalHealthIcon } from "../assets/icons/mental-health-icon";

export const MenuCategoryDictionary: IMenuCategoryDictionary = {
  [MenuItemCategory.RECOMMENDATIONS]: {
    Icon: RecommendationsIcon,
    color: NEW_BLUE_COLOR,
    subcategories: [
      MenuItemSubcategory.OVERVIEW,
      MenuItemSubcategory.MICRONUTRIENTS_TO_INCREASE,
      // MenuItemSubcategory.FINDINGS,
      MenuItemSubcategory.GENEVARIATIONS,
    ],
    hidden: false,
  },
  [MenuItemCategory.ORGANS]: {
    Icon: OrganIcon,
    color: GREEN_COLOR,
    subcategories: [
      MenuItemSubcategory.HEART,
      MenuItemSubcategory.BRAIN,
      MenuItemSubcategory.BONE,
      MenuItemSubcategory.JOINT,
      MenuItemSubcategory.EYE,
    ],
    hidden: false,
  },
  [MenuItemCategory.BLOOD]: {
    Icon: BloodIcon,
    color: RED_COLOR,
    subcategories: [MenuItemSubcategory.HOMOCYSTEINE, MenuItemSubcategory.HYPERTENSION],
    hidden: false,
  },
  [MenuItemCategory.METABOLISM]: {
    Icon: MetabolismIcon,
    color: PURPLE_COLOR,
    subcategories: [MenuItemSubcategory.OXIDATIVESTRESS, MenuItemSubcategory.DETOX, MenuItemSubcategory.METABOLISM],
    hidden: false,
  },
  [MenuItemCategory.MENTAL_HEALTH]: {
    Icon: MentalHealthIcon,
    color: YELLOW_COLOR,
    subcategories: [MenuItemSubcategory.RESILIENCE],
    hidden: false,
  },
  [MenuItemCategory.DIET]: {
    Icon: NutritionIcon,
    color: WARNING_COLOR,
    subcategories: [
      MenuItemSubcategory.RDA,
      MenuItemSubcategory.GLUTEN,
      MenuItemSubcategory.LACTOSE,
      // MenuItemSubcategory.FRUCTOSE,
      // MenuItemSubcategory.MICRONUTRIENTS,
    ],
    hidden: false,
  },
  [MenuItemCategory.MICRONUTRIENTS]: {
    Icon: MicronutrientsIcon,
    color: BLUE_COLOR,
    subcategories: [MenuItemSubcategory.MICRONUTRIENTS, MenuItemSubcategory.RDA],
    hidden: true,
  },
  [MenuItemCategory.TOTAL]: {
    subcategories: [MenuItemSubcategory.TOTAL],
    geneDataGroupArea: GeneDataGroupArea.TOTAL,
    hidden: true,
  },
  [MenuItemCategory.USER]: {
    subcategories: [],
    hidden: true,
  },
};

export interface IMenuSubCategory {
  isQuestionBased: boolean;
  bodypart: BODYPART;
  geneDataGroupTypes: GeneDataGroupType[];
}

export const MenuSubcategoryDictionary: IMenuSubcategoryDictionary = {
  [MenuItemSubcategory.HOMOCYSTEINE]: {
    isQuestionBased: true,
    bodypart: BODYPART.BLOOD,
    geneDataGroupTypes: [GeneDataGroupType.HOMOCYSTEINE, GeneDataGroupType.HOMOCYSTEINE_B2],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.HYPERTENSION]: {
    isQuestionBased: true,
    bodypart: BODYPART.BLOOD,
    geneDataGroupTypes: [GeneDataGroupType.HYPERTENSION],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.HEART]: {
    isQuestionBased: true,
    bodypart: BODYPART.HEART,
    geneDataGroupTypes: [GeneDataGroupType.HEART],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.BRAIN]: {
    isQuestionBased: true,
    bodypart: BODYPART.BRAIN,
    geneDataGroupTypes: [GeneDataGroupType.BRAIN],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.BONE]: {
    isQuestionBased: true,
    bodypart: BODYPART.BONES,
    geneDataGroupTypes: [GeneDataGroupType.BONE],
    enabledForDemo: true,
  },
  [MenuItemSubcategory.JOINT]: {
    isQuestionBased: true,
    bodypart: BODYPART.BONES,
    geneDataGroupTypes: [GeneDataGroupType.JOINT],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.EYE]: {
    isQuestionBased: true,
    bodypart: BODYPART.EYES,
    geneDataGroupTypes: [GeneDataGroupType.EYE],
    enabledForDemo: false,
  },

  [MenuItemSubcategory.GLUTEN]: {
    isQuestionBased: true,
    bodypart: BODYPART.DIGESTIVE,
    geneDataGroupTypes: [GeneDataGroupType.GLUTEN],
    enabledForDemo: true,
  },
  [MenuItemSubcategory.LACTOSE]: {
    isQuestionBased: true,
    bodypart: BODYPART.DIGESTIVE,
    geneDataGroupTypes: [GeneDataGroupType.LACTOSE],
    enabledForDemo: true,
  },
  [MenuItemSubcategory.OXIDATIVESTRESS]: {
    isQuestionBased: true,
    bodypart: BODYPART.DIGESTIVE,
    geneDataGroupTypes: [GeneDataGroupType.OXIDATIVESTRESS],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.DETOX]: {
    isQuestionBased: true,
    bodypart: BODYPART.LIVER,
    geneDataGroupTypes: [GeneDataGroupType.DETOX],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.METABOLISM]: {
    isQuestionBased: true,
    bodypart: BODYPART.DIGESTIVE,
    geneDataGroupTypes: [GeneDataGroupType.METABOLISM],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.MICRONUTRIENTS]: {
    isQuestionBased: true,
    bodypart: undefined,
    geneDataGroupTypes: [GeneDataGroupType.MICRONUTRIENTS],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.OVERVIEW]: {
    isQuestionBased: false,
    pages: [Overview],
    bodypart: undefined,
    geneDataGroupTypes: [GeneDataGroupType.TOTAL],
    enabledForDemo: true,
  },
  [MenuItemSubcategory.MICRONUTRIENTS_TO_INCREASE]: {
    isQuestionBased: false,
    pages: [NutrientsToIncrease, NutrientsToDecrease],
    explanations: [Explanation.NUTRIENT, Explanation.NUTRIENT],
    bodypart: undefined,
    geneDataGroupTypes: [GeneDataGroupType.TOTAL],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.RESILIENCE]: {
    isQuestionBased: true,
    bodypart: undefined,
    geneDataGroupTypes: [GeneDataGroupType.RESILIENCE],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.GENEVARIATIONS]: {
    isQuestionBased: false,
    pages: [GeneVariation, GeneVariations],
    explanations: [null, Explanation.GENE_VARIATIONS],
    bodypart: undefined,
    geneDataGroupTypes: [GeneDataGroupType.TOTAL],
    enabledForDemo: true,
  },
  [MenuItemSubcategory.RDA]: {
    isQuestionBased: true,
    bodypart: undefined,
    geneDataGroupTypes: [GeneDataGroupType.RDA],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.TOTAL]: {
    isQuestionBased: true,
    bodypart: undefined,
    geneDataGroupTypes: [GeneDataGroupType.TOTAL],
    enabledForDemo: false,
  },
  [MenuItemSubcategory.USER_DATA]: {
    isQuestionBased: false,
    pages: [UserData],
    geneDataGroupTypes: [],
    bodypart: undefined,
    hideFooter: true,
    enabledForDemo: false,
  },
  [MenuItemSubcategory.FAVOURITES]: {
    isQuestionBased: false,
    pages: [UserFavourites],
    geneDataGroupTypes: [],
    bodypart: undefined,
    hideFooter: true,
    enabledForDemo: true,
  },
  [MenuItemSubcategory.USER_REPORTS]: {
    isQuestionBased: false,
    pages: [UserReports],
    geneDataGroupTypes: [],
    bodypart: undefined,
    hideFooter: true,
    enabledForDemo: true,
  },
};

export const ColorCategoryDictionary: IColorCategoryDictionary = {
  [MenuItemCategory.RECOMMENDATIONS]: {
    color: NEW_BLUE_COLOR,
    lightColor: fade(NEW_BLUE_COLOR, 0.3),
  },
  [MenuItemCategory.BLOOD]: {
    color: RED_COLOR,
    lightColor: RED_COLOR_LIGHT,
  },
  [MenuItemCategory.ORGANS]: {
    color: GREEN_COLOR,
    lightColor: GREEN_COLOR_LIGHT,
  },
  [MenuItemCategory.MENTAL_HEALTH]: {
    color: YELLOW_COLOR,
    lightColor: lighten(YELLOW_COLOR, 0.3),
  },
  [MenuItemCategory.DIET]: {
    color: WARNING_COLOR,
    lightColor: WARNING_COLOR_LIGHT,
  },
  [MenuItemCategory.METABOLISM]: {
    color: PURPLE_COLOR,
    lightColor: PURPLE_COLOR_LIGHT,
  },
  [MenuItemCategory.MICRONUTRIENTS]: {
    color: BLUE_COLOR,
    lightColor: BLUE_COLOR_LIGHT,
  },
  [MenuItemCategory.TOTAL]: {
    color: PRIMARY_COLOR,
    lightColor: PRIMARY_COLOR_LIGHT,
  },
  [MenuItemCategory.USER]: {
    color: PRIMARY_COLOR,
    lightColor: PRIMARY_COLOR_LIGHT,
  },
};

export const ExplanationsDictionary: IExplanationDictionary = {
  [Explanation.NUTRIENT]: [NutrientIndicatorExplanation],
  [Explanation.GENE_VARIATIONS]: [GeneVariationExplanation],
};
